import { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';

const points = [
  { icon: 'ri-search-eye-line', text: '依學習階段、生活空間與手感協助評估' },
  { icon: 'ri-scales-3-line', text: '不是買最貴，而是找最適合你的那一把' },
  { icon: 'ri-hand-heart-line', text: '先感受、先熟悉，再決定是否需要擁有' },
  { icon: 'ri-shield-check-line', text: '不在一開始就強迫購買' },
];

export default function InstrumentSection() {
  const [visible, setVisible] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.1 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={ref} className="py-24 md:py-32 bg-[#f2ede5]">
      <div className="w-full px-6 md:px-12 lg:px-20">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Image */}
          <div
            className={`transition-all duration-700 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
          >
            <div className="rounded-2xl overflow-hidden" style={{ aspectRatio: '4/3' }}>
              <img
                src="https://storage.helloreaddy.io/project_files/79c1f631-1cb7-456b-a6cf-fdd8ff21e9a0/6a7290e5-2ebf-411d-a3d8-c28bd3648a2b_compressed_C-Image-202695-04_45_30.webp"
                alt="古箏買賣"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          {/* Text */}
          <div
            className={`transition-all duration-700 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
            style={{ transitionDelay: '0.2s' }}
          >
            <div className="flex items-center gap-3 mb-6">
              <div className="divider-gold"></div>
              <span className="text-[0.8125rem] tracking-[0.2em] text-[#9a8470] font-medium uppercase">Instrument</span>
            </div>

            <h2
              className="font-serif-tc text-[#2c2420] leading-[1.4] mb-6"
              style={{ fontSize: 'clamp(1.5rem, 3vw, 2.125rem)' }}
            >
              選箏諮詢<br />
              <span className="text-[#9a8470]">找到最適合你的那一把</span>
            </h2>

            <p className="text-[1.1875rem] leading-[1.75] text-[#5a4e42] mb-8">
              選箏不是買最貴的，而是找最適合你的。我會依照你的學習階段、生活空間、手感回饋，一起幫你評估什麼樣的古箏更適合現在的你。
            </p>

            <ul className="space-y-4 mb-10">
              {points.map((p, i) => (
                <li key={i} className="flex items-center gap-4">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#faf8f5] shrink-0">
                    <i className={`${p.icon} text-[#7a6248] text-lg`}></i>
                  </div>
                  <p className="text-[1.1875rem] leading-[1.75] text-[#4a3e32]">{p.text}</p>
                </li>
              ))}
            </ul>

            <Link
              to="/instrument"
              className="inline-flex items-center gap-3 px-7 py-3.5 rounded-full bg-[#4a3e32] hover:bg-[#3a2e22] text-[#f5f0e8] text-[1rem] font-medium transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              了解選箏服務
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line text-sm"></i>
              </div>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
